<template>
  <div class="login-callback-container">
    <div class="minimal-loading">
      <div class="loading-spinner"></div>
      <p>Verifying authentication...</p>
    </div>
  </div>
</template>

<script>
import router from '../../router';
import tokenManagerService, { oktaAuth } from '../../services/tokenManager';

export default {
  name: 'AuthLoginCallback',
  
  // Guard to prevent double-execution within the same component instance
  data() {
    return {
      processing: false
    };
  },

  async mounted() {
    // 1. Check if the SDK recognizes this as a valid callback URL
    // If there is no 'code' or 'state' in the URL, we shouldn't be here.
    if (!oktaAuth.isLoginRedirect()) {
      console.warn("⚠️ Loaded callback route without auth params. Redirecting home.");
      router.replace('/');
      return;
    }

    await this.processCallback();
  },

  methods: {
    async processCallback() {
      if (this.processing) return; // Prevent double-calls
      this.processing = true;

      try {
        console.log("🔄 Processing login callback...");

        // Attempt the code exchange
        const originalTarget = await tokenManagerService.handleLoginCallback();
        
        console.log("✅ Login successful.");
        this.navigateAway(originalTarget);

      } catch (error) {
        console.error("❌ Login callback error:", error);

        // === THE FIX IS HERE ===
        // If the error is "Could not load PKCE codeVerifier", it implies the code
        // might have already been exchanged in a parallel process.
        // Let's check if we actually HAVE a valid token now.
        if (this.isPkceError(error)) {
          console.warn("⚠️ PKCE Error detected. Checking if we are actually authenticated...");
          const token = await tokenManagerService.getValidToken();
          
          if (token) {
            console.log("✅ False alarm. Token exists. Proceeding...");
            this.navigateAway();
            return;
          }
        }

        // If we really failed, go back to login
        this.handleFailure(error);
      }
    },

    /**
     * Helper to detect the specific PKCE error
     */
    isPkceError(error) {
      return (
        error.name === 'AuthSdkError' && 
        (error.message.includes('PKCE') || error.message.includes('codeVerifier'))
      );
    },

    navigateAway(target) {
      router.replace({ 
        path: "/auth/processing", 
        query: { redirect: target } 
      });
    },

    handleFailure(error) {
      let queryError = 'login_failed';
      if (error.errorCode === 'login_required') queryError = 'session_expired';
      
      router.replace({ path: '/signin', query: { error: queryError } });
    }
  },
};
</script>

<style scoped>
/* Your existing styles are perfectly fine, kept them exactly as is */
.login-callback-container {
  min-height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(#1e1e2f, #1e1e24);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
}

.minimal-loading {
  text-align: center;
  color: white;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.minimal-loading p {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
</style>